<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('점검대상') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid xl:grid-cols-10 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <!--        체크 1-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
            {{ inspectionTitle_1 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 2-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
            {{ inspectionTitle_2 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 3-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_3"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_3 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_3"
            ></vs-checkbox>
            {{ inspectionTitle_3 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 4-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_4"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_4 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_4"
            ></vs-checkbox>
            {{ inspectionTitle_4 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 5-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_5"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_5 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_5"
            ></vs-checkbox>
            {{ inspectionTitle_5 }}
          </span>
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_3"
      :list="form.inspectList_3"
      @update-list-check="updateListCheck_3"
      v-if="form.check_3"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_4"
      :list="form.inspectList_4"
      @update-list-check="updateListCheck_4"
      v-if="form.check_4"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_5"
      :list="form.inspectList_5"
      @update-list-check="updateListCheck_5"
      v-if="form.check_5"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.inspectList_1 ||
          this.form.inspectList_1.length === 0
        ) {
          this.form.inspectList_1 = this.inspectTable_1;
        }
        if (
          !this.form ||
          !this.form.inspectList_2 ||
          this.form.inspectList_2.length === 0
        ) {
          this.form.inspectList_2 = this.inspectTable_2;
        }
        if (
          !this.form ||
          !this.form.inspectList_3 ||
          this.form.inspectList_3.length === 0
        ) {
          this.form.inspectList_3 = this.inspectTable_3;
        }
        if (
          !this.form ||
          !this.form.inspectList_4 ||
          this.form.inspectList_4.length === 0
        ) {
          this.form.inspectList_4 = this.inspectTable_4;
        }
        if (
          !this.form ||
          !this.form.inspectList_5 ||
          this.form.inspectList_5.length === 0
        ) {
          this.form.inspectList_5 = this.inspectTable_5;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = `${
          value.check_1 ? this.inspectionTitle_1 : ""
        }
            ${value.check_2 ? this.inspectionTitle_2 : ""}
            ${value.check_3 ? this.inspectionTitle_3 : ""}
            ${value.check_4 ? this.inspectionTitle_4 : ""}
            ${value.check_5 ? this.inspectionTitle_5 : ""}`;

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle_1: "토공사·기초공사",
      inspectionTitle_2: "골조공사",
      inspectionTitle_3: "내부 마감공사",
      inspectionTitle_4: "외부 마감공사",
      inspectionTitle_5: "지붕공사",

      form: {
        inspectionTitle: "",
        stdInfo: {},
        photoList: [],
        check_1: true,
        check_2: false,
        check_3: false,
        check_4: false,
        check_5: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
        inspectList_4: [],
        inspectList_5: [],
      },
    };
  },
  computed: {
    inspectTable_1() {
      return [
        {
          id: 1,
          label:
            "작업 시작 전 작업장소 및 주변의 부석·균열 유무, 함수·용수와 동결상태의  변화를 점검한다. ",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "사전에 지하매설물(상·하수도 관로 및 도시가스관 등) 및 지상 지장물(전신주 및 가공전선로 등)을 모두 이설 또는 방호 조치한다. ",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "굴착면의 높이가 2미터 이상인 경우 토질 상태를 사전조사 하고 그 결과를  고려하여 작업계획서를 작성한다. ",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "굴착사면 또는 흙막이지보공 붕괴위험에 대해 굴착 작업 전·진행 중 수시  확인하고 그 위험성을 즉시 제거한다. ",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "흙막이 붕괴방지를 위해 필요한 계측을 실시하고 이상변위 시 즉시 조치한다.",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "과굴착 하지 않도록 사전 굴착계획에 따라 작업을 진행하고 토류판을 적기에 설치한다.",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "토사반출 작업을 위한 복공판 설치 등 충분한 작업공간을 확보하고 차량계건설기계 등이 안전하게 운행·작업 하도록 한다. ",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "흙막이 지보공 조립 시 버팀대, 띠장 등 상부에 추락방지용 안전시설을 반드시 설치한다.",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "근로자가 지하 굴착작업 장소까지 이동할 수 있도록 가설계단 등 안전한통로를 확보하여야 한다.",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "클램쉘 등으로 굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가 출입하지 않토록 통제한다.",
          is_checked: "",
        },
        {
          id: 11,
          label:
            "트렌치 굴착 시에는 작업 여건, 위험도 등에 따라 간이 흙막이를 설치하거나 굴착면의 안전 기울기를 확보하여야 한다.",
          is_checked: "",
        },
      ];
    },
    inspectTable_2() {
      return [
        {
          id: 1,
          label: "거푸집동바리 구조 검토를 실시하고 조립도를 작성하여야 한다. ",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "거푸집동바리 조립도(동바리, 수평연결재, 가새재 위치 등)에 따라  조립하여야 한다.",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "거푸집·동바리 조립 시 상부에 자재 과적으로 인한 붕괴위험이 없도록  조치한다. ",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "작업자에게 적정한 개인보호구(안전모, 안전대 등)를 지급하고  추락 등 위험 시 반드시 안전대를 걸고 작업하여야 한다. ",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "거푸집 설치-해체-인양작업 시 안전조치 사항에 대해 작업자가 충분히  숙지하도록 특별안전교육을 실시한다.",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "슬래브 단부, 개구부 등의 추락방호조치는 적절하게 실시하여야 한다.",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "철근조립 등 고소 작업을 위한 작업발판은 작업장소·위치 등을 고려하여  적정하게 사용하여야 한다. ",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "고소작업대 사용 시 발 스위치 연동장치, 조작레버 덮개 등의 안전장치 설치와 장비제원, 운전원 실명 등을 부착·관리한다.",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "콘크리트 펌프카는 아웃트리거를 최대한 인출하고 작업계획서에 따라 관계자외 출입금지, 타설순서 등을 준수하여야 한다.",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "클램쉘 등으로 콘크리트 양생(갈탄, 열풍기 보온양생) 시 산소·유해가스농도를 수시로 측정하고 출입자는 호흡용 보호구를 반드시 착용한다.굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가출입하지 않토록 통제한다.",
          is_checked: "",
        },
      ];
    },
    inspectTable_3() {
      return [
        {
          id: 1,
          label:
            "자재(벽돌, 블록, 시멘트, 모래, 물 등)는 작업에 필요한 수량만큼 수시로 안전하게 운반하여 사용한다. ",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "자재 운반 시 다른 작업에 방해되지 않도록 충분한 공간을 확보하고  운반용기계·기구 필요 시 안전성을 검토하여 사용하여야 한다.",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "내부 마감공사용 이동식비계, 말비계 등의 작업발판은 충분한 안전성을  확보하도록 설치하고 필요한 안전조치를 한다.",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "작업장 주변과 근로자 이동통로 상의 개구부에는 방호조치 및 안전표지를 부착하여야 한다.",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "작업자에게 적절한 개인보호구를 지급하고 올바르게 착용하도록 하여야 한다.",
          is_checked: "",
        },
        {
          id: 6,
          label: "작업 장소로 이동하기 위한 안전한 통로를 확보하여야 한다.",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "천장 마감재 상부 에어컨 설치 등의 작업은 마감재 설치 전에 완료하고 마감재위로 작업자가 올라가지 않도록 한다.",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "정화조, 저수조 등 밀폐된 공간 내에서 방수 작업 시 질식위험을 제거하여야 한다.",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "벽체·천장 작업용 내부 비계 설치 시에는 사전에 조립도를 작성하고 필요한 안전조치 및 작업자 이동통로를 확보한다.",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "방수제 등 사용하는 화학물질에 대한 경고표시를 부착하고, 각 물질에 대한 MSDS를 작업자에게 교육한다.",
          is_checked: "",
        },
      ];
    },
    inspectTable_4() {
      return [
        {
          id: 1,
          label:
            "외부비계 상 벽돌 등 자재는 필요한 수량만큼 적재하여 비계기둥 간의 적재하중은 400kg을 초과하지 않도록 한다.",
          is_checked: "",
        },
        {
          id: 2,
          label:
            "외부 비계 상 근로자 승강통로는 작업자가 이용하기 쉽도록 충분한 수량을 설치하여야 한다.",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "외벽과 비계 사이에는 높이 10미터 이내마다 추락방호망을 설치하고 작업에 간섭이 되지 않는 한 안전시설을 해체하지 않는다. ",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "단열재 등 가연성 물질 주변에서 용접 작업 시 불티 비산방지 등 화재예방조치를 반드시 하여야 한다.",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "달비계 작업 전 로프 등 자재를 점검하고 달비계 로프 설치 시 작업자가 안전대를 부착하도록 관리감독을 확실히 한다. ",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "달비계 작업용 섬유로프 및 구명줄은 절단·마모 보호를 위해 보호덮개를  설치해야하며, 견고한 고정점에 결속하여야 한다.",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "석재 운반용 윈치 사용 시 고정부위가 안전한지 검토하고 줄걸이 방법 등을사전에 확인하여 안전하게 작업하여야 한다.",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "외부마감 작업 장소로 작업자가 안전하게 이동하기 위한 통로를 확보하여야 한다.",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "비계 조립 작업 시 주변에 특고압 전선 유무를 사전 확인하여 안전한 작업방법을 검토하고 벽이음 등을 간격에 맞춰 설치한다.",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "차량탑재형 고소작업대 사용 시 아웃트리거를 최대한 인출하고 탑승자는반드시 안전대를 부착한다.",
          is_checked: "",
        },
      ];
    },
    inspectTable_5() {
      return [
        {
          id: 1,
          label:
            "강도가 약해 깨지기 쉬운 지붕 위에서 작업 시 반드시 30센티미터 이상의  작업발판을 설치해야 한다. ",
          is_checked: "",
        },
        {
          id: 2,
          label: "채광창이 있는 경우 견고한 덮개를 설치해야 한다. ",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "지붕 가장자리에는 안전난간을 설치해야 하며, 곤란한 경우 추락 방호망을 설치하거나 안전대를 착용해야 한다. ",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "지붕의 형태, 구조 등을 사전 파악하여 적절한 이동통로, 작업발판설치 등  추락방지 조치를 하여야 한다.",
          is_checked: "",
        },
        {
          id: 5,
          label:
            "지붕진입을 위한 승강설비(고정식 사다리, 워킹타워 등)를 적정하게 설치한다.",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "지붕 위에 자재를 집중 또는 과적하지 않도록 한다.",
          is_checked: "",
        },
        {
          id: 7,
          label:
            "슬레이트, 채광창(skyligt) 지붕의 노후상태를 확인하고, 취약한 지붕재(슬레이트, 채광창 등)에 적절한 추락방호조치(발판, 안전덮개, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다.",
          is_checked: "",
        },
        {
          id: 8,
          label:
            "지붕 단부에 추락방호조치(안전난간, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다. ",
          is_checked: "",
        },
        {
          id: 9,
          label: "지붕 위 작업 시 가공전선에 접촉위험이 없도록 한다. ",
          is_checked: "",
        },
        {
          id: 10,
          label:
            "작업 전 기상 및 지붕표면 상태를 확인하여 전도위험 등이 있는 경우 작업을 중지한다. ",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck_1(indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text;
    },
    updateListCheck_2(indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text;
    },
    updateListCheck_3(indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text;
    },
    updateListCheck_4(indexRows, text) {
      this.form.inspectList_4[indexRows].is_checked = text;
    },
    updateListCheck_5(indexRows, text) {
      this.form.inspectList_5[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
